/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { useRef, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import Label from "../../components/label";
import ICDateInput from "../../components/form/dateInput";
import ICSelect from "../../components/form/selectInput";
import DefaultUserImg from "../../assets/images/default-picture.png";
import InputMask from "react-input-mask";
import moment from "moment-timezone";


const EditProfileForm = props => {
  // For profile picture
  const inputUserProfilePic = useRef(null);
  const [userProfilePic, setuserProfilePic] = useState(null);
  const [photoRowData, setPhotoRowData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [stateList, setStateList] = useState([]);
  const [timezoneList, setTimezoneList] = useState([
    {
      val: "Australia/Sydney", _id: "Australia/Sydney"
    },
    {
      val: "Australia/Melbourne", _id: "Australia/Melbourne"
    },
    {
      val: "Australia/Brisbane", _id: "Australia/Brisbane"
    },
    {
      val: "Australia/Perth", _id: "Australia/Perth"
    },
    {
      val: "Australia/Adelaide", _id: "Australia/Adelaide"
    },
    {
      val: "Australia/Darwin", _id: "Australia/Darwin"
    }
  ]);
  const [enableReinitialize, setEnableReinitialize] = useState(true);
  const [userDob, setUserDob] = useState('');
  const [dateChanged, setDateChanged] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: userData ? userData.firstName : '',
      middleName: userData ? userData.middleName : '',
      lastName: userData ? userData.lastName : '',
      abn: userData ? userData.ABN : '',
      // dob: userData ? userData.dateOfBirth.replace(/-/g, '/'): '',
      dob: userData && userDob ? userDob : '',
      gender: userData ? userData.gender : '',
      mobileNo: userData ? userData.phoneNumber : '',
      ec1Name: userData && userData.ec1 && userData.ec1.name ? userData.ec1.name : '',
      ec1ContactNo: userData && userData.ec1 && userData.ec1.contact ? userData.ec1.contact : '',
      ec2Name: userData && userData.ec2 && userData.ec2.name ? userData.ec2.name : '',
      ec2ContactNo: userData && userData.ec2 && userData.ec2.contact ? userData.ec2.contact : '',
      profilePic: userData && userData.profilePic ? userData.profilePic.original : "",
      emailId: userData ? userData.email : '',
      unitNo: (userData && userData.address.unitNumber ? userData.address.unitNumber : '') + ' ' + (userData && userData.address.streetNumber ? userData.address.streetNumber : ''),
      stName: userData ? userData.address.streetName : '',
      suburb: userData ? userData.address.suburb : '',
      postCode: userData ? userData.address.postCode : '',
      state: userData && stateList.length ? userData.address.state : 'Select State',
      timeZone: userData && userData.timeZone ? userData.timeZone : 'Select Timezone'
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please enter the First Name"),
      lastName: Yup.string().required("Please enter the Last Name"),
      emailId: Yup.string()
        .email("Invalid email")
        .required("Please enter the Email Address"),
      mobileNo: Yup.string()
               .matches(/([0-9]{4}[0-9]{3}[0-9]{3})/, 'Please enter correct Mobile Number')
               .required("Please enter the Mobile Number"),
      unitNo: Yup.string().required("Please enter Unit/Street Number"),
      stName: Yup.string().required("Please enter Street Name"),
      suburb: Yup.string().required("Please enter Suburb"),
      postCode: Yup.string()
              .matches(/([0-9]{4})/, 'Please enter correct Postcode')
              .required("Please enter Postcode"),
      ec1ContactNo: Yup.string()
                .matches(/([0-9]{4}[0-9]{3}[0-9]{3}|([0-9]{2}(_){8}))/, 'Please enter correct Mobile Number'),
      ec2ContactNo: Yup.string()
                .matches(/([0-9]{4}[0-9]{3}[0-9]{3}|([0-9]{2}(_){8}))/, 'Please enter correct Mobile Number')               
    }),
    enableReinitialize: enableReinitialize,
    onSubmit: formValues => {      
      const bodyData = new FormData();
      bodyData.append("ec1", JSON.stringify({ "name": formValues.ec1Name, "contact": formValues.ec1ContactNo }));
      bodyData.append("ec2", JSON.stringify({ "name": formValues.ec2Name, "contact": formValues.ec2ContactNo }));
      bodyData.append("email", formValues.emailId);
      bodyData.append("ABN", formValues.abn);
      bodyData.append("firstName", formValues.firstName);
      bodyData.append("lastName", formValues.lastName);
      bodyData.append("dateOfBirth", dateChanged ? formValues.dob : userData.dateOfBirth);
      bodyData.append("gender", formValues.gender);
      bodyData.append("phoneNumber", formValues.mobileNo.replace(/ /g, ''));
      bodyData.append("streetNumber", formValues.unitNo);
      bodyData.append("streetName", formValues.stName);
      bodyData.append("suburb", formValues.suburb);
      bodyData.append("state", formValues.state);
      bodyData.append("postCode", formValues.postCode);
      bodyData.append("timeZone", formValues.timeZone);
      if (photoRowData) {
        bodyData.append("profilePhoto", photoRowData);
        bodyData.append("isFile", true);
      } else {
        bodyData.append("isFile", false);
      }
      console.log(" formValues.timeZone : ", formValues.timeZone)
      props.onFormSubmit(bodyData);
    }
  });

  // For Profile Pic input
  const handleFileInput = () => {
    inputUserProfilePic.current.click();
  };

  const onChangeHandler = event => {
    if (event.target.files && event.target.files[0]) {
      setuserProfilePic(URL.createObjectURL(event.target.files[0]));
      setPhotoRowData(event.target.files[0]);
    }
  };

  const convertDateToISO = (dateToConvert) => {
    let str = dateToConvert;
    let darr = str.split("-");
    let dobj = new Date(parseInt(darr[2]), parseInt(darr[1]) - 1, parseInt(darr[0]));
    return dobj.toISOString();
  }

  useEffect(() => {
    setuserProfilePic(props.userData && props.userData.profilePic ? props.userData.profilePic.original : DefaultUserImg);
    setUserData(props.userData);
    if (props.userData) {
      let dateIs = convertDateToISO(props.userData.dateOfBirth);
      setUserDob(dateIs);
    }

    if (props.userData && props.userData.address) {
      formik.values.state = props.userData.address.state;
    }
  }, [props.userData]);

  useEffect(() => {
    setStateList(props.stateList);
    if (props.userData && props.userData.length) formik.values.state = props.userData.address.state;
  }, [props.stateList]);

  useEffect(() => {
    if (props.stateList && props.stateList.length && props.userData) {
      setTimeout(() => {
        setEnableReinitialize(false);
      }, 2000)
    };
  }, [props.stateList, props.userData])

  return (
    <form className="w-100" onSubmit={formik.handleSubmit}>
      <div className="row p-4">
        <Label
          className="gray large ml-2 pl-1 w-100"
          title="Basic Information"
        />
        <div className="col-sm-4">
          <Label className="gray small" title="First Name" required={true} />
          <ICInput
            id="firstName"
            name="firstName"
            label=""
            placeholder="First"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.firstName}
            error={
              formik.touched.firstName && formik.errors.firstName ? true : false
            }
            helperText={
              formik.touched.firstName && formik.errors.firstName
                ? formik.errors.firstName
                : ""
            }
            disabled={true}
          />
        </div>
        <div className="col-sm-4">
          <Label className="gray small" title="Middle Name" />
          <ICInput
            id="middleName"
            name="middleName"
            label=""
            placeholder="Middle"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.middleName}
            disabled={true}
          />
        </div>
        <div className="col-sm-4">
          <Label className="gray small" title="Last Name" required={true} />
          <ICInput
            id="lastName"
            name="lastName"
            label=""
            placeholder="Last"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.lastName}
            error={
              formik.touched.lastName && formik.errors.lastName ? true : false
            }
            helperText={
              formik.touched.lastName && formik.errors.lastName
                ? formik.errors.lastName
                : ""
            }
            disabled={true}
          />
        </div>

        <div className="col-sm-6 mt-4">
          <Label className="gray small" title="Date of Birth" required={true} />
          {
            userDob && userDob !== '' ?
              (
                <ICDateInput
                  id="dob"
                  name="dob"
                  className="cal-primary-bg pt-6"
                  label=""
                  defaultDate={userDob}
                  handleChange={val => {
                    formik.values.dob = val;
                    formik.setFieldValue(
                      "dob",
                      moment(val).format("DD-MM-YYYY")
                    );
                    setDateChanged(true);
                    setUserDob(moment(new Date(val)).format("DD-MM-YYYY"));
                    formik.handleChange("dob");
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.dob}
                  error={
                    formik.touched.dob && formik.errors.dob
                      ? true
                      : false
                  }
                  helperText={
                    formik.touched.dob && formik.errors.dob
                      ? formik.errors.dob
                      : ""
                  }
                />
              ) : ''
          }

          {formik.errors.dob && formik.touched.dob ? (
            <Label
              title="Please select Date of Birth"
              className="small error"
            />
          ) : (
              ""
            )}
          {/* <ICDateInput
            id="dob"
            name="dob"
            className="cal-primary-bg"
            label=""
            defaultDate={false}
            handleChange={date => console.log(date)}
          /> */}
        </div>

        <div className="col-sm-6 mt-4">
          <Label className="gray small" title="Gender" required={true} />
          <ICSelect
            label=""
            placeholder="Select Gender"
            id="gender"
            name="gender"
            useId="_id"
            useValue="val"
            items={[
              { _id: "Male", val: "Male" },
              { _id: "Female", val: "Female" }
            ]}
            value={formik.values.gender}
            onBlur={formik.handleBlur}
            handleChange={val => {
              formik.values.gender = val;
              formik.setFieldValue("gender", val);
              formik.handleChange("gender");
            }}
            error={formik.touched.gender && formik.errors.gender ? true : false}
            helperText={
              formik.touched.gender && formik.errors.gender
                ? formik.errors.gender
                : ""
            }
          />
          {formik.errors.gender && formik.touched.gender ? (
            <Label title="Please select Gender" className="small error" />
          ) : (
              ""
            )}

          {/* <ICSelect
            label=""
            placeholder="Select Gender"
            id="gender"
            items={[
              { _id: "1", val: "Male" },
              { _id: "2", val: "Female" }
            ]}
            value={formik.values.gender}
            handleChange={val => console.log(val)}
          /> */}
        </div>
      </div>

      <div className="row mt-1 p-4">
        <Label
          className="gray large ml-2 pl-1 w-100"
          title="Contact Information"
        />

        <div className="col-sm-6">
          <Label className="gray small" title="Email Address" required={true} />
          <ICInput
            id="emailId"
            name="emailId"
            label=""
            placeholder="Email Address"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.emailId}
            error={
              formik.touched.emailId && formik.errors.emailId ? true : false
            }
            helperText={
              formik.touched.emailId && formik.errors.emailId
                ? formik.errors.emailId
                : ""
            }
          />
        </div>
        <div className="col-sm-6">
          <Label
            className="gray small mb-1"
            title="Mobile Number"
            required={true}
          />
           <InputMask
            mask="0499999999"
            value={formik.values.mobileNo}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.mobileNo && formik.errors.mobileNo
                ? true
                : false
            }
            helperText={
              formik.touched.mobileNo && formik.errors.mobileNo
                ? formik.errors.mobileNo
                : ""
            }
          >
            {inputProps => (
              <ICInput
                id="mobileNo"
                name="mobileNo"
                label=""
                placeholder="Mobile Number"
                {...inputProps}
              />
            )}
          </InputMask>
          {/* <ICInput
            id="mobileNo"
            name="mobileNo"
            label=""
            placeholder="Mobile Number"
            className="pt-1"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.mobileNo}
            error={
              formik.touched.mobileNo && formik.errors.mobileNo ? true : false
            }
            helperText={
              formik.touched.mobileNo && formik.errors.mobileNo
                ? formik.errors.mobileNo
                : ""
            }
          /> */}
        </div>
      </div>

      <div className="row p-4">
        <Label
          className="gray large ml-2 pl-2 w-100"
          title="Address Information"
        />
        <div className="col-sm-4">
          <Label
            className="gray small"
            title="Unit Number/Street Number"
            required={true}
          />
          <ICInput
            id="unitNo"
            name="unitNo"
            label=""
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.unitNo}
            error={formik.touched.unitNo && formik.errors.unitNo ? true : false}
            helperText={
              formik.touched.unitNo && formik.errors.unitNo
                ? formik.errors.unitNo
                : ""
            }
          />
        </div>
        <div className="col-sm-4">
          <Label className="gray small" title="Street Name" required={true} />
          <ICInput
            id="stName"
            name="stName"
            label=""
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.stName}
            error={formik.touched.stName && formik.errors.stName ? true : false}
            helperText={
              formik.touched.stName && formik.errors.stName
                ? formik.errors.stName
                : ""
            }
          />
        </div>
        <div className="col-sm-4">
          <Label className="gray small" title="Suburb" required={true} />
          <ICInput
            id="suburb"
            name="suburb"
            label=""
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.suburb}
            error={formik.touched.suburb && formik.errors.suburb ? true : false}
            helperText={
              formik.touched.suburb && formik.errors.suburb
                ? formik.errors.suburb
                : ""
            }
          />
        </div>
        <div className="col-sm-6 mt-4">
          <Label className="gray small" title="State" required={true} />
          <ICSelect
            label=""
            placeholder="Select State"
            id="state"
            name="state"
            items={stateList}
            useId="stateId"
            useValue="stateId"
            value={formik.values.state}
            onBlur={formik.handleBlur}
            handleChange={val => {
              formik.values.state = val;
              formik.setFieldValue("state", val ? val : '');
              formik.handleChange("state");
            }}
            error={formik.touched.state && formik.errors.state ? true : false}
            helperText={
              formik.touched.state && formik.errors.state
                ? formik.errors.state
                : ""
            }
          />
          {formik.errors.state && formik.touched.state ? (
            <Label title="Please select State" className="small error" />
          ) : (
              ""
            )}

          {/* <ICSelect
            label=""
            placeholder="Select State"
            id="state"
            items={[
              { _id: "1", val: "QLD" },
              { _id: "2", val: "VIC" }
            ]}
            value={formik.values.state}
            handleChange={val => console.log(val)}
          /> */}
        </div>
        <div className="col-sm-6 mt-4">
          <Label className="gray small" title="Postcode" required={true} />
          <InputMask
            mask="9999"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.postCode}
            error={
              formik.touched.postCode && formik.errors.postCode ? true : false
            }
            helperText={
              formik.touched.postCode && formik.errors.postCode
                ? formik.errors.postCode
                : ""
            }
          >
            {inputProps => (
              <ICInput
                id="postCode"
                name="postCode"
                label=""
                placeholder=""
                {...inputProps}
              />
            )}
          </InputMask>
          {/* <ICInput
            id="postCode"
            name="postCode"
            label=""
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.postCode}
            error={
              formik.touched.postCode && formik.errors.postCode ? true : false
            }
            helperText={
              formik.touched.postCode && formik.errors.postCode
                ? formik.errors.postCode
                : ""
            }
          /> */}
        </div>
      </div>

      <div className="row mt-1 p-4">
        <Label
          className="gray large ml-2 pl-1 w-100"
          title="Other Information"
        />

        <div className="col-sm-6">
          <Label className="gray small" title="ABN Number" required={true} />
          <ICInput
            id="abn"
            name="abn"
            label=""
            placeholder="ABN"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.abn}
            error={formik.touched.abn && formik.errors.abn ? true : false}
            helperText={
              formik.touched.abn && formik.errors.abn ? formik.errors.abn : ""
            }
          />
        </div>
        <div className="col-sm-6">
          <Label className="gray small" title="Timezone" required={true} />
          <ICSelect
            label=""
            placeholder="Select TimeZone"
            id="timeZone"
            name="timeZone"
            items={timezoneList}
            useId="_id"
            useValue="val"
            value={formik.values.timeZone}
            handleChange={val => {
              formik.values.timeZone = val;
              formik.setFieldValue("timeZone", val ? val : '');
              formik.handleChange("timeZone");
            }}
          />
        </div>
      </div>

      <div className="row mt-1 p-4">
        <Label
          className="gray large ml-2 pl-1 w-100"
          title="Emergency Contacts"
        />
        <Label className="gray ml-3 mt-2 w-100" title="Emergency Contacts 1" />

        <div className="col-sm-6">
          <Label className="gray small" title="Name" />
          <ICInput
            id="ec1Name"
            name="ec1Name"
            label=""
            placeholder="Name"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.ec1Name}
            error={
              formik.touched.ec1Name && formik.errors.ec1Name ? true : false
            }
            helperText={
              formik.touched.ec1Name && formik.errors.ec1Name
                ? formik.errors.ec1Name
                : ""
            }
          />
        </div>

        <div className="col-sm-6">
          <Label className="gray small" title="Contact Number" />
          <InputMask
            mask="0499999999"
            value={formik.values.ec1ContactNo}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.ec1ContactNo && formik.errors.ec1ContactNo
                ? true
                : false
            }
            helperText={
              formik.touched.ec1ContactNo && formik.errors.ec1ContactNo
                ? formik.errors.ec1ContactNo
                : ""
            }
          >
            {inputProps => (
              <ICInput
                id="ec1ContactNo"
                name="ec1ContactNo"
                label=""
                placeholder="Contact Number"
                {...inputProps}
              />
            )}
          </InputMask>
          {/* <ICInput
            id="ec1ContactNo"
            name="ec1ContactNo"
            label=""
            placeholder="Contact Number"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.ec1ContactNo}
            error={
              formik.touched.ec1ContactNo && formik.errors.ec1ContactNo
                ? true
                : false
            }
            helperText={
              formik.touched.ec1ContactNo && formik.errors.ec1ContactNo
                ? formik.errors.ec1ContactNo
                : ""
            }
          /> */}
        </div>

        <Label className="gray ml-3 mt-4 w-100" title="Emergency Contacts 2" />

        <div className="col-sm-6">
          <Label className="gray small" title="Name" />
          <ICInput
            id="ec2Name"
            name="ec2Name"
            label=""
            placeholder="Name"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.ec2Name}
            error={
              formik.touched.ec2Name && formik.errors.ec2Name ? true : false
            }
            helperText={
              formik.touched.ec2Name && formik.errors.ec2Name
                ? formik.errors.ec2Name
                : ""
            }
          />
        </div>

        <div className="col-sm-6">
          <Label className="gray small" title="Contact Number" />          
          <InputMask
            mask="0499999999"
            value={formik.values.ec2ContactNo}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.ec2ContactNo && formik.errors.ec2ContactNo
                ? true
                : false
            }
            helperText={
              formik.touched.ec2ContactNo && formik.errors.ec2ContactNo
                ? formik.errors.ec2ContactNo
                : ""
            }
          >
            {inputProps => (
              <ICInput
                id="ec2ContactNo"
                name="ec2ContactNo"
                label=""
                placeholder="Contact Number"
                {...inputProps}
              />
            )}
          </InputMask>
          {/* <ICInput
            id="ec2ContactNo"
            name="ec2ContactNo"
            label=""
            placeholder="Contact Number"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.ec2ContactNo}
            error={
              formik.touched.ec2ContactNo && formik.errors.ec2ContactNo
                ? true
                : false
            }
            helperText={
              formik.touched.ec2ContactNo && formik.errors.ec2ContactNo
                ? formik.errors.ec2ContactNo
                : ""
            }
          /> */}
        </div>
      </div>

      <div className="row p-4">
        <Label className="gray large ml-3 w-100" title="Upload" />
        <div className="col-sm-6 ic-doctor-pic">
          <Label className="gray small w-100" title="Profile Pic" />
          <img
            src={userProfilePic ? userProfilePic : DefaultUserImg}
            alt="ic-user"
            className="user-img rounded-circle float-left"
          />
          <div className="user-picture-div" onClick={handleFileInput}>
            <i className="fas fa-file-upload ic-file-upload-icon mt-2 float-left grey"></i>
            <Label
              title="Choose File"
              className="mt-4 choose-file-lbl gray ml-2"
            />
            <Label
              title="JPG, GIF or PNG. Max size of 2MB"
              className="p-0 ex-small clearfix w-100"
            />
            <input
              type="file"
              id="file"
              ref={inputUserProfilePic}
              style={{ display: "none" }}
              onChange={onChangeHandler}
            />
          </div>
        </div>
      </div>

      <div className="row mt-4 mb-3">
        <div className="col-sm-12 text-center mt-5 ">
          <Button type="submit" className="ml-3" />
        </div>
      </div>
    </form>
  );
};

export default EditProfileForm;

EditProfileForm.defaultProps = {
  serverErrorMsg: ""
};

EditProfileForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string
};
